import React, { useRef } from 'react'
import { trans } from '../../../../_providers/Translation'

//partials
import View from '../partials/modals/View'
import Options from './Options'
import Question from '../../../modals/messages/Question'

//images
import loader from '../../../../assets/img/loader.svg'
import checkIcon from '../../../../assets/img/icons/check.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import flagImage from "@/assets/img/todo/icons/flag.svg"
import flagActiveImage from "@/assets/img/todo/icons/flag-active.svg"
import minimizeImage from "@/assets/img/todo/icons/minimize.svg"

import NoDataFound from '../../../partials/NoDataFound'
import { useAuthDataContext } from '../../../../_providers/Auth'
import Api from '../../../../_helpers/Api'

// providers
import { useNotesContext } from '@/_providers/Notes'
import Skeleton from 'react-loading-skeleton'

function Table(props) {
    const { getMinimizedTodos, loadingTray } = useNotesContext()

    const auth = useAuthDataContext()

    const viewModalRef = useRef(null)
    const repeatModalRef = useRef(null)

    const handleView = data => {
        viewModalRef.current.open(data)
    }

    const handleStopRepeat = id => {
        let modal = repeatModalRef.current

        modal.open()
        modal.onSuccess(() => {
            Api.post('todos/stop-repeat', {
                id: id
            }).then(res => {
                if (res.data.success) {
                    props.refreshData()
                }
            })
        })
    }

    function getMinimizedTodosIds() {
        return getMinimizedTodos().map(each => each.todo_id)
    }

    function isTodoMinimized(id) {
        return getMinimizedTodosIds().includes(id)
    }

    return (
        <>

            <View
                ref={viewModalRef}
                handleRead={props.handleRead}
            />

            <Question
                ref={repeatModalRef}
                mainMessage={trans('headings.question1')}
            />

            {props.loading
                ?
                <Skeleton height={45} count={5} />
                :
                props.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    {/* <th className="todo-check"></th> */}
                                    <th className="options">
                                    </th>
                                    <th>ID</th>
                                    <th className="center"><img src={flagImage} alt="flag head" /></th>
                                    <th>{trans('tables.createdBy')}</th>
                                    <th>{trans('tables.setTo')}</th>
                                    {!auth.isAdmin() &&
                                        <th>{trans('tables.reservation')}</th>
                                    }
                                    <th>{trans('tables.heading')}</th>
                                    <th>{trans('tables.datePriority')}</th>
                                    <th>{trans('tables.deadline')}</th>
                                    <th className="options">{trans('tables.options')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* //NEW: Добавяне на флаг */}
                                {props.data.map(todo =>
                                    <tr key={'todo-' + todo.id}>
                                        <td className="center">
                                            <button
                                                onClick={() => props.handleAddToTray(todo.id)}
                                                style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    borderRadius: "50%",
                                                    minWidth: "initial",
                                                    padding: 0,
                                                    margin: "0 auto",
                                                    pointerEvents: loadingTray || isTodoMinimized(todo.id) ? 'none' : 'auto',
                                                    opacity: isTodoMinimized(todo.id) ? 0.4 : 1,
                                                    filter: loadingTray ? 'blur(2px)' : 'none'
                                                }}
                                            >
                                                <img src={minimizeImage} alt="minimize" />
                                            </button>
                                        </td>
                                        {/* <td className="todo-check">{todo.completed_at && <img src={checkIcon} alt="completed" />}</td> */}
                                        <td>{todo.id}</td>
                                        <td className="center">
                                            <button
                                                className={`flag-btn${todo.flagged ? ' flagged' : ''}`}
                                                onClick={() => props.handleFlag(todo.id)}
                                                title={todo.flagged ? trans('tables.removeFlag') : trans('tables.flag')}
                                                style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    borderRadius: "50%",
                                                    minWidth: "initial",
                                                    padding: 0,
                                                    margin: "0 auto"
                                                }}
                                            >
                                                <img src={todo.flagged ? flagActiveImage : flagImage} alt="flag" />
                                            </button>
                                        </td>
                                        <td>
                                            {/* //NEW: Показване на името на партньора, ако е споделена задача */}
                                            {todo.shared === 1 && todo.isOwner === false && todo.shared_by_partner_name
                                                ? `${todo.shared_by_partner_name} (${trans('labels.partner')})`
                                                : (todo.author ? `${todo.author.name} ${todo.author.lastname}` : '')}
                                        </td>
                                        <td>
                                            {/* //NEW: Показване на името на партньора, ако е споделена задача */}
                                            {todo.isOwner === true && todo.shared === 1 && todo.shared_with_partner_name
                                                ? `${todo.shared_with_partner_name} (${trans('labels.partner')})`
                                                : (() => {
                                                    const tags = Array.isArray(todo.tags) ? todo.tags : []
                                                    return tags.map(tag => {
                                                        if (tag.employee && tag.employee.name) {
                                                            return `${tag.employee.name} ${tag.employee.lastname || ''}`
                                                        }

                                                        if (tag.partner && tag.partner.name) {
                                                            return `${tag.partner.name} (${trans('labels.partner')})`
                                                        }

                                                        return ''
                                                    }).filter(each => each !== '').join(', ')
                                                })()}
                                        </td>
                                        {!auth.isAdmin() &&
                                            <td>
                                                {todo.reservation
                                                    ?
                                                    <a
                                                        href={'/schedule/reservations/edit/' + todo.reservation_id} target="_blank"
                                                    // className="btn"
                                                    // style={{ background: todo.reservation.color, color: todo.reservation.text_color }}
                                                    >
                                                        {todo.reservation.reference_code}
                                                    </a>
                                                    :
                                                    ''
                                                }
                                            </td>
                                        }
                                        <td>
                                            {todo.title}
                                        </td>
                                        <td>
                                            {todo.date_dmy}
                                            <p className={`priority-holder priority-text ${todo.priority && todo.priority.name ? todo.priority.name : ''}`} style={{
                                                fontWeight: 'bold',
                                                fontSize: '10px',
                                            }}>
                                                {todo.priority && todo.priority.translation ? todo.priority.translation.name : ''}
                                            </p>
                                        </td>
                                        <td>{todo.deadline_dmy}</td>
                                        <td>
                                            <Options
                                                isOwner={todo.isOwner}
                                                id={todo.id}
                                                data={todo}
                                                read={todo.read_at}
                                                completed={todo.completed_at}
                                                canMarkAsCompleted={todo.can_mark_as_completed}
                                                paused={todo.paused_at}
                                                handleEdit={props.handleEdit}
                                                handleDelete={props.handleDelete}
                                                handleRead={props.handleRead}
                                                handleComplete={props.handleComplete}
                                                handleTogglePause={props.handleTogglePause}
                                                handleView={handleView}
                                                handleStopRepeat={handleStopRepeat}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

            }
        </>
    )
}

export default Table